import { CustomerInfo } from '../modules/agent-call-view/models/agent-call-model';

/* eslint-disable */
export interface DndStates {
  name: string;
  value: string;
}
export interface GlobalInfo {
  DndStates: DndStates[];
}
export interface ProfileInfo {
  Profiles: Profile[];
}
export interface SessionInfo {
  userId: string;
  tenantId: string;
  firstName: string;
  lastName: string;
  authenticated: boolean;
  activityState: callStates;
  receiveReady: string;
  sipRegistered: boolean;
  sipUser: string;
  onCall: string;
  currentCallId: string;
  TenantId: string;
  agentId: string;
  allowManualCalls: boolean;
  language: string;
}
export interface StatsInfo {
  profileStatsInfo: ProfileStatsInfo;
  sessionStatsInfo: SessionStatsInfo;
}
export interface ProfileStatsInfo {
  profileId: string;
  callCount: number;
  contacts: string;
  dialTime: string;
  pitch: string;
  saleCount: number;
  talkTime: number;
  verified: number;
  wrapupTime: number;
}
export interface SessionStatsInfo {
  averageTalkTime: number;
  averageWaitTime: number;
  averageWrapupTime: number;
  breakTime: number;
  loginTime: number;
  idleTime: number;
  totalCalls: number;
  totalSales: number;
  totalTalkTime: number;
  totalWrapupTime: number;
  voicemailTime: number;
  waitTime: number;
}

export interface Profile {
  id: string;
  name: string;
  type: string;
  agentScreenContext: string;
  controlledRecording: boolean;
  hasAgentScreenContext: boolean;
  customScriptingUrl: string;
  hasCustomScripting: boolean;
  externalScript: boolean;
  disallowManualCalls: boolean;
  loadCustomScripting: boolean;
  campaign: Campaign;
  transferOptions: TransferOptions[];
  dispositions: Dispositions[];
  externalScriptIsRedirect: boolean;
  isPlayConnection: boolean;
}

export interface Dispositions {
  name: string;
  type: string;
  description: string;
}

export interface Campaign {
  id: string | null;
  name: string | null;
  callbackColumns: string[];
  indexedColumns: string[];
}

export enum callStates {
  IDLE = 'Idle',
  TALKING = 'Talking',
  MANUAL = 'Manual',
  DIALING = 'Dialing',
  ENDED = 'Ended',
  UNAVAILABLE = 'Unavailable',
  WRAP_UP = 'Wrapup',
  AVAILABLE = 'Available',
  BREAK = 'Break',
  PREVIEWING = 'Previewing',
  VOICE_MAIL = 'Voicemail',
}

export enum DialTypes {
  DEFAULT = 'Default',
  PREDICTIVE = 'Predictive',
  PREVIEW = 'Preview',
  PREVIEW_WITH_TRIGGER = 'PreviewManual',
  ACD_QUEUE = 'ACD Queue',
  MANUAL = 'MANUAL',
  CONFIGURE_ROUTE = 'Configure Route',
}

export enum CallTypes {
  CONFERENCE = 'Conference',
  TRANSFER = 'Transfer',
  MANUAL = 'Manual',
  INBOUND = 'Inbound',
  OUTBOUND = 'Outbound',
  DEFAULT = 'Default',
}

export enum CALL_ACTION_EVENTS {
  END_CALL = 'EndCall',
  BLIND_TRANSFER = 'BlindTransfer',
  HANGUP = 'Hangup',
  HOLD = 'Hold',
  RECORD_START = 'RecordStart',
  RECORD_STOP = 'RecordStop',
  RECORD_PAUSE = 'RecordPause',
  RECORD_RESUME = 'RecordResume',
  RESUME = 'Resume',
  CONFERENCE = 'Conference',
  TRANSFER = 'Transfer',
  POSTCALL_ACTION = 'PostCall',
}

export enum USM_EVENTS {
  LOGIN = 'Login',
  INFO = 'Info',
  RECEIVE_READY = 'ReceiveReady',
  CALL = 'Call',
  PREVIEW_MANUAL_CALL = 'PreviewManualCall',
  PREVIEW_MANUAL = 'PreviewManual',
  LOGOUT = 'Logout',
  CALL_BACK = 'Callback',
  CALL_CHANGE = 'CallChange',
  CALL_ACTION = 'CallAction',
  CALL_HANGUP = 'CallHangup',
  CALL_RESULT = 'CallResult',
  INFO_CHANGED = 'InfoChanged',
  SIP_REG_CHANGE = 'SipRegistrationChanged',
  SIP_TIMEOUT = 'SipRegistrationTimeout',
  SHUTDOWN = 'Shutdown',
  BREAK = 'Break',
  AVAILABLE = 'Available',
  UNAVAILABLE = 'Unavailable',
  NonQuery = 'NonQuery',
  CONTACT_LOOKUP = 'ContactLookup',
  DIAL = 'Dial',
  USM_DIAL_RESULT = 'UsmDialResult',
  LIVE_CALLS = 'LiveCalls',
  CALL_MONITOR = 'CallMonitor',
  WHISPER_ACTION = 'Whisper',
  WHISPER_CANCEL_ACTION = 'CancelWhishper',
  BARGE_ACTION = 'Barge',
  DROP_AGENT = 'DropAgent',
  CALL_END = 'EndCall',
  REAL_TIME_EXTENSIONS = 'RealTimeExtensions',
  UPDATE_AGENT_STATUS = 'UpdateAgentStatus',
}

export interface CallInfo {
  callId: string | null;
  contactId: string;
  contactNumber: string;
  countryCode?: string;
  languageCode?: string;
  callDuration?: string;
  returnCallTimerDuration?: string;
  isTransferred: boolean;
  isRecording: boolean;
  isUsingTenantScriptUrl: string;
  playbacks: any[];
  postcalls: any[];
  profileId: string;
  profileDialType: string;
  supervisedTransfer: string;
  profile: Profile;
  customerDetails?: CustomerInfo;
  isDropped?: boolean;
  dropRequest?: boolean;
  previewCancel?: boolean;
  isScriptLoaded?: boolean;
  transferProfileId?: string;
}
export interface ConferenceInfo {
  callId: string | null;
  contactId: string;
  contactNumber: string;
  profileId: string;
  profileDialType: string;
  type: 'Conference';
  IsRemoteAgentConnected: boolean;
  isDropped?: boolean;
  isMerged?: boolean;
  dropRequest?: boolean;
}
export interface TransferInfo {
  callId: string | null;
  contactId: string;
  contactNumber: string;
  profileId: string;
  profileDialType: string;
  isMerged?: boolean;
  type: 'Attended';
}
export interface TransferOptions {
  name: string;
  type: string;
  value: TransferOptionsValues[] | boolean;
}

export interface TransferOptionsValues {
  name: string;
  type?: string;
  value: string;
  countryCode: string;
}
